import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	['title', 'description', 'buttonName', 'dismissLabel']
> = defineContent({
	default: {
		title: {
			id: 'jira-crossflow-recommendation-confluence.banner-title',
			defaultMessage: 'Create and organize docs, all in one place',
			description: 'Title for the Confluence crossflow recommendation banner',
			role: 'title',
		},
		description: {
			id: 'jira-crossflow-recommendation-confluence.banner-description',
			defaultMessage:
				'With Confluence, you can write docs that are connected to your work in Jira, so work stays in sync.',
			description: 'Description for the Confluence crossflow recommendation banner',
			role: 'description',
		},
		buttonName: {
			id: 'jira-crossflow-recommendation-confluence.banner-button',
			defaultMessage: 'Try it',
			description: 'CTA button text for the Confluence crossflow recommendation banner',
		},
		dismissLabel: {
			id: 'jira-crossflow-recommendation-confluence.banner-dismiss',
			defaultMessage: 'Dismiss',
			description: 'Dismiss button label for the Confluence crossflow recommendation banner',
		},
	},
});
